'use client';
export default function BannerBottomSection() {
  return (
    <section id="banner-2" className="pt-20">
      <div
        className="relative overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1504813184591-01572f98c85f?w=1600&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}>
        
        {/* Overlay */}
        <div className="absolute inset-0" style={{ background: 'rgba(10,63,36,0.88)' }} />

        <div className="max-w-7xl mx-auto px-4 py-20 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* IMAGE */}
            <div className="w-full lg:w-5/12">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1cd20c43b-1766579806805.png"
                alt="Médecin africain en blouse blanche avec stéthoscope debout avec confiance dans un couloir d'hôpital moderne"
                className="w-full rounded-2xl shadow-2xl object-cover"
                style={{ height: '420px', objectPosition: 'top center' }} />
            </div>

            {/* TEXT */}
            <div className="w-full lg:w-7/12 lg:pl-8">
              <span
                className="block text-xs font-bold uppercase tracking-widest mb-4"
                style={{ color: '#fbaf45' }}>
                Franchise Médicale COSA
              </span>
              <h3
                className="text-3xl md:text-4xl font-black text-white mb-6"
                style={{ fontFamily: 'Lato, sans-serif' }}>
                Un Modèle d'Exécution aux Standards Internationaux
              </h3>
              <p className="mb-8 leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)' }}>
                Gérer un centre médical implique une gestion rigoureuse de l'ensemble des processus nécessaires pour garantir la qualité. En tant que franchiseur, COSA s'engage à apporter cette expertise au franchisé à travers une assistance technique complète, avec une infrastructure et un plateau technique conformes aux normes standards internationales.
              </p>
              <a
                href="#"
                className="inline-block border-2 border-white text-white px-8 py-3 rounded font-bold text-sm uppercase tracking-wide transition-all"
                style={{ letterSpacing: '0.5px' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0e5932';
                  e.currentTarget.style.borderColor = '#0e5932';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#fff';
                }}>
                Notre Modèle de Franchise
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

}